import React, { useEffect, useRef, useState } from "react";
import { createRoulette } from "../roulette";

function Roulette() {
  const rouletteCss = `
  .roulette-root { position: relative; width: 100%; height: 100vh; background: #000; }
  .roulette-canvas { position: absolute; inset: 0; }
  .settings { position: fixed; bottom: 1rem; left: 1rem; background: #666; border-radius: 10px; padding: 10px; z-index: 999; min-width: 35%; display: flex; visibility: visible; opacity: 1; transition: visibility 0s, opacity 1s linear; }
  .settings.hide { opacity: 0; visibility: hidden; }
  .settings h3 { padding: 0; margin: 0; font-size: 12pt; color: #fefefe; }
  .settings textarea { width: 100%; min-height: 5rem; border: none; background: #999; font-size: 14pt; }
  .settings button { color: #fefefe; background: #222; border: none; border-radius: 5px; padding: 5px 10px; position: relative; overflow: hidden; }
  .settings .icon { background: currentColor; mask-repeat: no-repeat; mask-position: center center; mask-size: contain; display: inline-block; width: 25px; height: 25px; vertical-align: middle; }
  .settings .icon.play { mask-image: url('/roulette-assets/images/play.svg'); }
  .settings .icon.shuffle { mask-image: url('/roulette-assets/images/shuffle.svg'); }
  .settings .icon.megaphone { mask-image: url('/roulette-assets/images/megaphone.svg'); }
  .settings .icon.record { mask-image: url('/roulette-assets/images/record.svg'); }
  .settings .icon.map { mask-image: url('/roulette-assets/images/map.svg'); }
  .settings .icon.trophy { mask-image: url('/roulette-assets/images/trophy.svg'); }
  .settings .icon.bomb { mask-image: url('/roulette-assets/images/bomb.svg'); }
  .settings .left { flex-grow: 1; flex-shrink: 1; order: 1; }
  .settings .left .actions { display: flex; align-items: center; justify-content: stretch; gap: 2px; }
  .settings .left .actions .sep { flex-grow: 1; }
  .settings .right { order: 2; flex-grow: 0; flex-shrink: 0; }
  .settings .right .row { display: flex; align-items: center; height: 35px; }
  .settings .right .row label { width: 150px; flex-grow: 0; flex-shrink: 0; padding-left: 1rem; color: white; }
  .settings select { height: 25px; width: 100%; border-radius: 5px; background: #999; }
  .settings input[type="checkbox"] { width: 0; height: 25px; position: relative; vertical-align: middle; }
  .settings input[type="checkbox"]:before { position: absolute; content: ''; display: inline-block; width: 50px; height: 25px; border-radius: 25px; background: #999; top: 0; left: 0; }
  .settings input[type="checkbox"]:after { position: absolute; top: 0; left: 0; content: ''; border-radius: 25px; width: 25px; height: 25px; background: #ccc; transition: transform .2s; }
  .settings input[type="checkbox"]:checked:after { transform: translateX(100%); background: white; }
  .settings input[type="checkbox"]:checked:before { content: ''; background: #00baff; }
  .btn-group { display: flex; justify-content: stretch; }
  .btn-group > * { box-sizing: border-box; flex-grow: 0; flex-shrink: 0; overflow: hidden; height: 25px; width: 33%; border-radius: 0; background: #999; border: none; padding: 0; color: #fefefe; display: flex; align-items: center; justify-content: center; }
  .btn-group > *:first-child { border-radius: 10px 0 0 10px; }
  .btn-group > *:last-child { border-radius: 0 10px 10px 0; }
  .btn-group > * .active:before { content: ''; width: 15px; height: 15px; display: inline-block; vertical-align: middle; mask-image: url('/roulette-assets/images/check.svg'); mask-repeat: no-repeat; background: white; }
  .btn-group > * .active { background: #333; }
  #notice { display: none; position: fixed; overflow: hidden; top: 50%; left: 50%; width: 500px; max-width: 90%; transform: translate(-50%, -50%); background: rgba(255,255,255,0.9); border-radius: 30px; z-index: 1001; padding: 10px 10px; color: #333; flex-direction: column; }
  #donate { position: fixed; bottom: calc(160px + 1.5rem); left: 1rem; z-index: 999; visibility: visible; opacity: 1; transition: visibility 0s, opacity 1s linear; }
  #donate.hide { opacity: 0; visibility: hidden; }
  @media screen and (max-width: 750px) {
    #donate { bottom: 2rem; }
    .settings { bottom: calc(2.5rem + 60px); display: block; min-width: 0; max-width: 100%; width: calc(100% - 2rem); overflow: hidden; opacity: 1; visibility: visible; transition: visibility 0s, opacity 1s linear; }
    .settings.hide { opacity: 0; visibility: hidden; }
    .settings .right .row { height: auto; display: block; border-bottom: 1px solid #555; padding: .5rem 0; }
    .settings .right .row label { width: 100%; margin-bottom: .5rem; padding-left: 0; display: block; }
    .settings .icon { width: 15px; height: 15px; }
  }
  .toast { position: fixed; transform: translate(-50%, 0); padding: 8px; border-radius: 4px; background: #ccc; overflow: hidden; bottom: 10px; left: 50%; z-index: 1000; animation: .2s linear fade-in, .2s linear 1s reverse fade-in; }
  @keyframes fade-in { 0% { opacity: 0; transform: translate(-50%, 100%); } 100% { opacity: 1; transform: translate(-50%, 0); } }
  `;
  const containerRef = useRef(null);
  const rouletteRef = useRef(null);
  const [names, setNames] = useState("짱구*5, 짱아*10, 봉미선*3");
  const [rank, setRank] = useState(1);
  const [maps, setMaps] = useState([]);
  const [mapIndex, setMapIndex] = useState(0);
  const [useSkills, setUseSkills] = useState(true);
  const [autoRecording, setAutoRecording] = useState(false);
  const [shakeAvailable, setShakeAvailable] = useState(false);
  const [winnerType, setWinnerType] = useState("first");

  useEffect(() => {
    window.scrollTo(0, 0);
    const container = containerRef.current;
    if (!container) return;
    rouletteRef.current = createRoulette(container);

    const onShakeAvailable = (e) => setShakeAvailable(!!e.detail);
    rouletteRef.current.addEventListener(
      "shakeAvailableChanged",
      onShakeAvailable
    );

    const init = () => {
      try {
        const list = rouletteRef.current.getMaps?.() || [];
        setMaps(list);
      } catch (e) {}
    };
    const t = setTimeout(init, 300);

    return () => {
      clearTimeout(t);
      if (rouletteRef.current) {
        rouletteRef.current.removeEventListener(
          "shakeAvailableChanged",
          onShakeAvailable
        );
      }
      rouletteRef.current = null;
    };
  }, []);

  const applyOptions = () => {
    window.options.useSkills = useSkills;
    window.options.autoRecording = autoRecording;
    window.options.winningRank = Math.max(0, Number(rank) - 1 || 0);
    if (rouletteRef.current) {
      rouletteRef.current.setWinningRank(window.options.winningRank);
      rouletteRef.current.setAutoRecording(window.options.autoRecording);
    }
  };

  const onShuffle = () => {
    applyOptions();
    const list = names
      .split(/[,\n]/)
      .map((v) => v.trim())
      .filter(Boolean);
    if (rouletteRef.current) {
      rouletteRef.current.setMarbles(list);
    }
  };

  const onStart = () => {
    applyOptions();
    const count = rouletteRef.current?.getCount?.() || 0;
    if (count === 0) {
      onShuffle();
    }
    rouletteRef.current?.start();
  };

  const onShake = () => {
    rouletteRef.current?.shake();
  };

  const onChangeMap = (e) => {
    const idx = Number(e.target.value || 0);
    setMapIndex(idx);
    rouletteRef.current?.setMap(idx);
  };

  const onWinnerFirst = () => {
    setWinnerType("first");
    setRank(1);
  };
  const onWinnerLast = () => {
    setWinnerType("last");
    const total = rouletteRef.current?.getCount?.() || 1;
    setRank(total);
  };

  return (
    <div className="roulette-root">
      <style>{rouletteCss}</style>
      <div id="settings" className="settings">
        <div className="right">
          <div className="row">
            <label>
              <i className="icon map"></i>
              <span data-trans>Map</span>
            </label>
            <select id="sltMap" value={mapIndex} onChange={onChangeMap}>
              {maps.map((map) => (
                <option key={map.index} value={map.index}>
                  {map.title}
                </option>
              ))}
            </select>
          </div>
          <div className="row">
            <label>
              <i className="icon record"></i>
              <span data-trans>Recording</span>
            </label>
            <input
              type="checkbox"
              id="chkAutoRecording"
              checked={autoRecording}
              onChange={(e) => setAutoRecording(e.target.checked)}
            />
          </div>
          <div className="row">
            <label>
              <i className="icon trophy"></i>
              <span data-trans>The winner is</span>
            </label>
            <div className="btn-group">
              <button
                className={`btn-winner btn-first-winner ${
                  winnerType === "first" ? "active" : ""
                }`}
                onClick={onWinnerFirst}
                data-trans
              >
                First
              </button>
              <button
                className={`btn-winner btn-last-winner ${
                  winnerType === "last" ? "active" : ""
                }`}
                onClick={onWinnerLast}
                data-trans
              >
                Last
              </button>
              <input
                type="number"
                id="in_winningRank"
                value={rank}
                min={1}
                onChange={(e) => {
                  setWinnerType("custom");
                  setRank(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="row">
            <label>
              <i className="icon bomb"></i>
              <span data-trans>Using skills</span>
            </label>
            <input
              type="checkbox"
              id="chkSkill"
              checked={useSkills}
              onChange={(e) => setUseSkills(e.target.checked)}
            />
          </div>
        </div>
        <div className="left">
          <h3 data-trans>Enter names below</h3>
          <textarea
            id="in_names"
            value={names}
            onChange={(e) => setNames(e.target.value)}
            placeholder="Input names separated by commas or line feed here"
            data-trans="placeholder"
          />
          <div className="actions">
            <button id="btnNotice">
              <i className="icon megaphone"></i>
            </button>
            <div className="sep"></div>
            <button id="btnShuffle" onClick={onShuffle}>
              <i className="icon shuffle"></i>
              <span data-trans>Shuffle</span>
            </button>
            <button id="btnStart" onClick={onStart}>
              <i className="icon play"></i>
              <span data-trans>Start</span>
            </button>
          </div>
        </div>
      </div>

      <div id="inGame" className={`settings ${shakeAvailable ? "" : "hide"}`}>
        <button id="btnShake" onClick={onShake} data-trans>
          Shake!
        </button>
      </div>

      <div ref={containerRef} className="roulette-canvas" />
    </div>
  );
}

export default Roulette;
